import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M33.554 11.44a1.5 1.5 0 0 1 0 2.12l-9.993 9.995a1.5 1.5 0 1 1-2.122-2.122l9.993-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M21.44 11.44a1.5 1.5 0 0 1 2.12 0l9.994 9.993a1.5 1.5 0 1 1-2.122 2.122L21.44 13.56a1.5 1.5 0 0 1 0-2.122"
      clipRule="evenodd"
    />
    <path fill="#0597A3" d="M41.5 109a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M77 101a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      fillRule="evenodd"
      d="M105.566 37a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V38.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      fillRule="evenodd"
      d="M97 45.566a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H98.5a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M17 37a2 2 0 0 1 2 2v50h80a2 2 0 1 1 0 4H17a2 2 0 0 1-2-2V39a2 2 0 0 1 2-2"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M87.495 23.671a2 2 0 0 1-.166 2.824L69.412 42.42 51.486 62.338a2 2 0 0 1-2.595.326L32.386 51.661l-13.85 16.62-3.073-2.561 15-18a2 2 0 0 1 2.646-.384l16.561 11.04 16.843-18.714a2 2 0 0 1 .158-.157l18-16a2 2 0 0 1 2.824.166"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M27 67a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v22H27zM63 59a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v30H63z"
    />
    <path
      fill="#00D8D8"
      d="M45 79a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v10H45zM81 43a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v46H81z"
    />
    <circle cx={50} cy={60} r={5} fill="#00D8D8" />
    <circle cx={68} cy={41} r={5} fill="#0597A3" />
    <circle cx={86} cy={25} r={5} fill="#00D8D8" />
    <circle cx={32} cy={49} r={5} fill="#0597A3" />
  </svg>
);
const SvgEnrichedIconFinancialManagementBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconFinancialManagementBrand);
export default Memo;
